import { render } from "./ExpendMoney.vue?vue&type=template&id=5236bb58&scoped=true"
import script from "./ExpendMoney.vue?vue&type=script&lang=js"
export * from "./ExpendMoney.vue?vue&type=script&lang=js"

import "./ExpendMoney.vue?vue&type=style&index=0&id=5236bb58&scoped=true&lang=less"

import exportComponent from "D:\\phpstudy_pro\\WWW\\guolang\\partner\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5236bb58"]])

export default __exports__